import React, {useContext} from 'react';
import { Badge, Box } from '@mui/joy';
import Auth0LogoutButton from '../../../mtska-frontend-modules/modules/Auth/views/Auth0/Auth0LogoutButton';
import { DrawerButton } from '../Drawer';
import { LanguageSwitcher } from '.';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { Button } from '../Button';

const UserMenu = () => {

    const { appConfiguration, user, userCapabilities } = useContext(AppContext);

    console.info('--------- UserMenu user', user, userCapabilities);

    const getFirstCharacter = (input) => {
        if (typeof input === 'string' || input instanceof String) {
            return input.charAt(0)
        }
        return 'N';
    }
    
    return (
        <Box className="user-menu">
            <Badge anchorOrigin={{ vertical: 'top', horizontal: 'left' }} variant='plain' badgeContent={Number.isInteger(user?.notificationsPending) ? parseInt(user?.notificationsPending) : 0} color="danger" size='sm' >
                {
                    appConfiguration.modules.active.some(item => item.name === "notificationuser") ?
                        <DrawerButton className="user-icon" drawerRoute={'notificationUsers/list'} params={{ removeSaveButton: true }} label={ <> { getFirstCharacter(user?.lastname)} </> } /> :
                        <Button className="user-icon" label={ <> { getFirstCharacter(user?.lastname)} </> } />
                }
            </Badge>
            <LanguageSwitcher />

            <Box className="user-name">{getFirstCharacter(user?.firstname) + ". " + user?.lastname}</Box>
            <Box className="user-email">{user?.roles}</Box>
            <Auth0LogoutButton className="user-logout"></Auth0LogoutButton>

        </Box>
    )
}

export default UserMenu
